import axios from 'axios';
import * as vars from './vars';

export function contactSupport (email, name, subject, message){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/misc/CreateSupportInquiry',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data : {
        email: email,
        name: name,
        subject: subject,
        message: message,
        }
    })
}

export function getSupportChatThread (jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/support/GetSupportChatThread',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : {}
    })
}

export function readSupportChatThread (jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/support/ReadSupportChatThread',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : {}
    })
}

export function sendSupportChatMessage (sendSupportChatMessageRequest, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/support/SendSupportChatThread',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : sendSupportChatMessageRequest
    })
}

export function getSupportArticles (jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/support/GetSupportArticles',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
    })
}

export function subscribeEmail (email){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/misc/CreateNewsletterSubscription',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data : {
            email: email,
        }
    })
}

export function serverPulseCheck (){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/misc/PulseCheck',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data : {}
    })
}
